import React from 'react';
import styled from 'styled-components';

import { AsbuiltComponentStyle } from './asbuilt-content';
import { AsbuiltPanelState } from './asbuilt-panel-state';

const AsbuiltPanel = () => {
  return (
    <Component>
      <AsbuiltPanelState />
    </Component>
  );
};

const Component = styled.div`
  position: absolute;
  z-index: 1;

  right: 2em;
  top: 4em;

  height: calc(100vh - 19em);
  width: 40vw;

  padding: 2em;

  ${AsbuiltComponentStyle} {
    height: 100%;
  }

  background-color: #fff;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
`;

export { AsbuiltPanel, Component as AsbuiltPanelStyled };
